<label *ngIf="label" >{{label}}</label>
<p-dropdown [options]="options" (onChange)="onChangeValue($event)" [placeholder]='placeholder' [optionLabel]='optionsLabelKey' [showClear]="true" [ngModel]="ngModel" [appendTo]="'body'" [style]="{'height':'100%','width':'100%'}">
    <ng-template let-option pTemplate="item">
            <div> {{this.capitalize(option[this.optionsLabelKey])}}</div>
    </ng-template>
</p-dropdown>
